; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/Modal',["jquery", "score_bootstrap/Components/Modal"], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("score_bootstrap/Components/Modal")) :
            console && console.error('ScheduledModalImage does not support non-amd script loading.');
}(this, function ($, ScoreModal) {

    function Modal(scope, stateChangeMessages, onShowMessagePerformer, onHideMessagePerformer, onShowMessagesTransmitter, onHideMessageTransmitter) {
        // Call inherited class constructor
        ScoreModal.call(this, scope, stateChangeMessages, onShowMessagePerformer, onHideMessagePerformer, onShowMessagesTransmitter, onHideMessageTransmitter);
    }
    // ToDo: this override should be removed after update of SCORE Bootstrap UI to version higher than v.3.5.8
    // Inherit prototype methods
    Modal.prototype = Object.create(ScoreModal.prototype);

    Modal.prototype.show = function show() {
        this.$scope.modal("show").attr("aria-hidden", "false");
        this.notifyOnShow();
    };

    Modal.prototype.hide = function hide() {
        this.$scope.modal("hide").attr("aria-hidden", "true");
        this.notifyOnHide();
    };

    Modal.init = function init(args) {
        return args.IsEditorEditing === true ? null : new Modal(
            args.scope,
            args.StateChangeMessagesTransmitting || [],
            args.ShowActionMessages || [],
            args.HideActionMessages || [],
            args.ShowMessagesTransmitting || [],
            args.HideMessagesTransmitting || []
        );
    };

    return Modal;
}));
